import { getTranslation } from '../../constants/translations';

import './EasyAs.scss';

export const EasyAs = () => {
  const t = getTranslation();

  const data = [
    {
      section: 'A',
      title: t.asEasyAs.sell.title,
      text: t.asEasyAs.sell.text,
    },
    {
      section: 'B',
      title: t.asEasyAs.collect.title,
      text: t.asEasyAs.collect.text,
    },
    {
      section: 'C',
      title: t.asEasyAs.monetize.title,
      text: t.asEasyAs.monetize.text,
    },
  ];

  return (
    <section className="main__easy-block easy-block" id="easy-block">
      <div className="_container">
        <h2 className="easy-block__title title">{t.asEasyAs.title}</h2>

        <div className="easy-block__cards-list">
          {data.map((card) => {
            return (
              <article
                key={card.section}
                className="easy-block__card easy-card"
              >
                <div className="easy-block__card-mark easy-card__mark">
                  {card.section}
                </div>

                <div className="easy-card__title">{card.title}</div>

                <p className="easy-card__text">{card.text}</p>

                {/* <button className="easy-card__button button">
                  {t.common.learnMore}
                </button> */}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
